import { render, staticRenderFns } from "./counterpartiesListBottom.vue?vue&type=template&id=5d28b44d"
import script from "./counterpartiesListBottom.vue?vue&type=script&lang=js"
export * from "./counterpartiesListBottom.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesListBottom.vue?vue&type=style&index=0&id=5d28b44d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports